import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import ExpenseForm from "../../components/Forms/ExpenseForm";
import { getMyUser, isAdministrator } from "../../store/session/selectors";
import { PermissionEnum } from "../../models";
import { ExpenseEntity } from "../../store/entities/state";
import { isSubmitting, getChangeLog, getChangingValue, getChangingState } from "../../store/entities/selectors";
import { entityEditionCancel, updateEntity, deleteEntity, loadEntityChangeLog, updateChangingEntity, loadEntities } from "../../store/entities/actions";
import { updateExpenseAsync, deleteExpenseAsync, getExpenseChangeLogAsync, getExpenseAsync } from "../../ajax/requests";
import { ExpenseFormDispatchProps, ExpenseFormStateProps } from "../../components/Forms/ExpenseForm/ExpenseForm";

const canEdit = (state: ApplicationState, ownProps: ExpenseFormProps) => {
    const user = getMyUser(state);
    return user?.permissions?.includes(PermissionEnum.Administrator) ||
        user?.permissions?.includes(PermissionEnum.PricesManagement) ||
        (!!user?.username && user.username === ownProps.data.createdBy);
};

export interface ExpenseFormProps {
    data: ExpenseEntity,
}

const mapStateToProps = (state: ApplicationState, ownProps: ExpenseFormProps): ExpenseFormStateProps => ({
    type: 'edit',
    canEdit: canEdit(state, ownProps),
    data: getChangingValue(state, 'expenses') as ExpenseEntity || ownProps.data,
    hasChanged: getChangingState(state, 'expenses'),
    isSubmitting: isSubmitting('expenses')(state),
    changeLog: getChangeLog(state, 'expenses', ownProps.data.id),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch, ownProps: ExpenseFormProps): ExpenseFormDispatchProps => ({
    onChange: (data: ExpenseEntity) => dispatch(updateChangingEntity('expenses', data)),
    onCancel: () => dispatch(entityEditionCancel('expenses')),
    onSave: async (data: ExpenseEntity, files?: File[]) => {
        await dispatch(updateEntity('expenses', data, e => updateExpenseAsync(e.id, e, files)));
        // Reload the expense from server if files were uploaded to get the proper attachment URLs
        if (files && files.length > 0) {
            await dispatch(loadEntities('expenses', () => getExpenseAsync(data.id), 'AppendResult'));
        }
    },
    onDelete: () => dispatch(deleteEntity('expenses', ownProps.data.id, d => deleteExpenseAsync(d))),
    onLoad: () => {
        dispatch(loadEntityChangeLog('expenses', ownProps.data.id, () => getExpenseChangeLogAsync(ownProps.data.id)));
    },
});

export default connect<ExpenseFormStateProps, ExpenseFormDispatchProps, ExpenseFormProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ExpenseForm as any);
